import { createContext } from 'react';
import type React from 'react';

export type SidebarHeaderSlotValue = {
  leading: React.ReactNode;
  banner?: React.ReactNode;
  chatHidden: boolean;
  /** The card editor already shows the selected card's title. */
  hideCardScope?: boolean;
  onShowChat: () => void;
};

export const SidebarHeaderSlot = createContext<SidebarHeaderSlotValue | null>(null);
